// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutMenu {
  height: 50px;
  width: 100%;
  line-height: 50px;
  border-bottom: 1px solid #ddd;
  background: #f5f5f5;
}
.aboutMenu ul {
  display: flex;
  width: 1200px;
  margin: 0px auto;
  border-left: 1px solid #ddd;
}
.aboutMenu ul li a {
  padding: 0px 25px;
  border-right: 1px solid #ddd;
  display: inline-block;
  font-size: 16px;
  height: 50px;
  color: #333;
  border-top: 1px solid #ddd;
}
.aboutMenu ul li.active a {
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Rongyu/index.less"],"names":[],"mappings":"AAAA;EAAW,YAAA;EAAa,WAAA;EAAY,iBAAA;EAAmB,6BAAA;EAA8B,mBAAA;AAMrF;AANA;EACM,aAAA;EAAe,aAAA;EAAc,gBAAA;EAAkB,2BAAA;AAWrD;AAZA;EAEW,iBAAA;EAAkB,4BAAA;EAA6B,qBAAA;EAAsB,eAAA;EAAgB,YAAA;EAC1F,WAAA;EAAY,0BAAA;AAkBlB;AArBA;EAKkB,gBAAA;AAmBlB","sourcesContent":[".aboutMenu{height:50px; width:100%; line-height: 50px; border-bottom:1px solid #ddd; background:#f5f5f5;\n   ul{display: flex; width:1200px; margin: 0px auto; border-left:1px solid #ddd;}\n   ul li a{padding:0px 25px; border-right:1px solid #ddd; display:inline-block; font-size:16px; height:50px; \n      color:#333; border-top:1px solid #ddd;\n   }\n   ul li.active a{background:#fff;}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
